<template>
    <div>
      <NextStepsV2/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import NextStepsV2 from '../components/NextStepsV2.vue';

export default {
  name: 'onboarding-next-steps',
  metaInfo: {
    title: 'Próximos passos',
  },
  components: {
    NextStepsV2,
  },
  methods: {
    ...mapActions('onboarding', [
      'emitEvent',
    ]),
  },
  mounted() {
    this.emitEvent({
      type: 'show',
      page: 'thank-you',
    });
  },
};

</script>

<style lang="scss" scoped>
  .onboarding-next-steps-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;

    background-color: var(--gray-100);
    min-height: 100vh;
    box-sizing: border-box;

    @media (max-width: $md) {
      background-color: var(--white);
      flex-direction: column;
      padding-top: 0;
    }
  }
  .left {
    width: 60%;
    background: #FFFFFF;
    padding-left: 12.5%
  }
  .right {
    width: 40%;
    padding-right: 12.5%;
    background-color: #F4F6F8;
  }
  .more-details {
    margin-top: -40px;
    display: flex;
    align-self: center;
    font-size: 16px;
    line-height: 24px;
    color: #36A3CA;
  }
  @media (max-width: $sm) {
    .left {
      width: 100%;
      background: #FFFFFF;
      height: 100vh;
    padding-left: unset;
    }
    .right {
      display: none;
    }
  }
</style>
<style>
.drawer-right-wrapper .drawer {
  width: 100%;
  height: 100%;
  padding-top: 30px;
  position: absolute;
  margin-right: 24px;
  left: 24px;
}
</style>
